import styled from "styled-components";

const Nickname = styled.p`
  font-size: 1.8rem;
  margin: 0 0 0.8rem 0;
`;

export default Nickname;
